/* eslint-disable */

// general error
export function error(...args) {
  console.error.apply(console, args);
}

export function info(...args) {
  console.info.apply(console, args);
}

export function warn(...args) {
  console.warn.apply(console, args);
}

export function log(...args) {
  console.log.apply(console, args);
}



// WEBPACK FOOTER //
// ./src/utils/logger.js